import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Pause icon. Exported from Figma (Bombiix 2026). */
const PauseIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <defs>
      <clipPath id="pause-icon-clip">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
    <g clipPath="url(#pause-icon-clip)">
      <g>
        <path
          d="M8.66634 12.6673L8.66634 7.33398M11.333 12.6673V7.33398M16.6663 10.0007C16.6663 13.6825 13.6816 16.6673 9.99967 16.6673C6.31778 16.6673 3.33301 13.6825 3.33301 10.0007C3.33301 6.31875 6.31778 3.33398 9.99967 3.33398C13.6816 3.33398 16.6663 6.31875 16.6663 10.0007Z"
          stroke="currentColor"
          strokeLinecap="round"
        />
      </g>
    </g>
  </svg>
);

export default PauseIcon;
